import { providerSelect } from 'modules/constants/amwell';
import { Provider, ProviderVisibility } from 'store/amwell/types';

export const getVisibilityAttr = (provider: Provider) => {
  switch (provider?.visibility) {
    case ProviderVisibility.WEB_AVAILABLE:
      return provider?.waitingRoomCount ? providerSelect.WAITING : providerSelect.AVAILABLE;
    case ProviderVisibility.OFFLINE:
      return providerSelect.OFFLINE;
    default:
      return providerSelect.WAITING;
  }
};
